/**
 * Service layer — Studio Documents (Employee Handbook, Mission & Core Values).
 *
 * Owns the studio_documents table (Supabase) behind the Clerk-authed /api/studio-documents
 * endpoint. Components never call the API directly — they go through here. See docs/STUDIO.md.
 */

async function token() {
  for (let i = 0; i < 25; i++) {
    if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* retry */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  const t = await token(); if (t) headers['Authorization'] = 'Bearer ' + t
  const res = await fetch('/api/studio-documents', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/studio-documents' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

export async function listStudioDocuments() {
  return (await post({ action: 'list' })).documents || []
}

export async function updateStudioDocument(slug, { title, bodyMarkdown, updatedByName } = {}) {
  return (await post({ action: 'update', slug, title, bodyMarkdown, updatedByName })).document
}
